<template>
  <div v-loading="loading" class="alarmClass">
    <div>
      <el-form :model="form" ref="formRef" :rules="formRules" label-suffix=":" label-width="0px">
        <el-row :gutter="24">
          <el-col :span="24">
          <el-table :data="form.tableData" style="width: 100%">
            <el-table-column prop="active" label="日常活动" width="200"> </el-table-column>
            <el-table-column prop="score" label="评分" width="250">
              <template slot-scope="scope">
                <el-form-item
                  :prop="`tableData.${scope.$index}.score`"
                  :rules="[{ required: true, message: '评分不能为空', trigger: 'change' }]"
                >
                  <el-input-number
                    v-model="scope.row.score"
                    :controls="false"
                    :min="0"
                    :max="scope.row.maxScore"
                    @blur="totalScoreCalculate"
                    :disabled="model == 'view'"
                  ></el-input-number>
                </el-form-item>
              </template>
            </el-table-column>
            <el-table-column prop="maxScore" width="80" label="最高分值"> </el-table-column>
            <el-table-column prop="standard" label="评估标准"> </el-table-column>
          </el-table>
        </el-col>
        <el-col :span="24">
          <span>总分：</span>
            <span>{{ totalScore }}</span>

        </el-col>
        </el-row>
      </el-form>
      <div style="text-align: right" >
      <el-button v-if="model != 'view'" type="primary" icon="el-icon-circle-plus-outline" @click="saveRecord" size="small">
        提交
      </el-button>

    </div>
    </div>
  </div>
</template>
<script>
import { getHealthAssessmen,submitAssessment } from '@/api/nursingHome/healthData.js';
export default {
  components: {},
  props: {
    row: {
      default: {},
    },
    nursinghomeId: {},
    model: {
      default: 'add',
    },
  },
  data() {
    return {
      formRules: {

        score: [{ required: true, message: '分数不能为空', trigger: 'blur' }],
      },
      propsList: [
        'eat',
        'bathe',
        'decorate',
        'dressing',
        'stoolControl',
        'useToilet',
        'moveBed',
        'walking',
        'upDownStairs',
      ],
      totalScore: 0,
      form:{
        tableData: [
      //   {
      //     active: '进食',
      //     score: '',
      //     standard: '10分，独立进食  5分，需部分帮助  0分，需极大帮助或完全依赖他人，或有留置胃管',
      //   },
      //   {
      //     active: '洗澡',
      //     score: '',
      //     standard: '5分，自己能够独立完成洗澡过程  0分，需他人帮助',
      //   },
      //   {
      //     active: '修饰：洗脸，刷牙，梳头，刮脸等',
      //     score: '',
      //     standard: '5分，可以独立完成  0分，需他们人帮助',
      //   },
      //   {
      //     active: '穿衣：穿脱衣服，系扣，拉拉链，穿拖鞋袜',
      //     score: '',
      //     standard: '10分，可独立完成  5分 ，需部分帮助  0分，需极大帮助或完全依赖他人',
      //   },
      //   {
      //     active: '大便控制',
      //     score: '',
      //     standard: '10分，可控制大便  5分 ，偶尔失控（每周＜1次），需他人提醒  0分，完全失控',
      //   },
      //   {
      //     active: '如厕：解开衣裤、擦净、整理衣裤、冲水',
      //     score: '',
      //     standard: '10分，可独立完成  5分 ，需部分帮助  0分，需极大帮助或完全依赖他人',
      //   },
      //   {
      //     active: '座椅转移',
      //     score: '',
      //     standard:
      //       '15分，可独立完成  10分，需部分帮助（需他人搀扶或使用使用拐杖）  5分 ，需部分帮助  0分，完全依赖他人',
      //   },
      //   {
      //     active: '平地行走',
      //     score: '',
      //     standard:
      //       '15分，可独立在平地上行走45m  10分，需部分帮助（需他人搀扶或使用使用拐杖）  5分 ，需部分帮助  0分，完全依赖他人',
      //   },
      //   {
      //     active: '上下楼梯',
      //     score: '',
      //     standard:
      //       '10分，可独立上下楼梯（10-15个台阶） 5分，需部分帮助 0分，需极大帮助或完全依赖他人',
      //   },
      ],
      },

    };
  },
  created() {
    this.initData();
  },
  mounted() {},
  watch: {},
  methods: {
    totalScoreCalculate() {

      this.totalScore = 0
      this.form.tableData.forEach((item) => {
        console.log(item)
        if(item.scope!=""&&item.score!=undefined){
          this.totalScore += Number(item.score);
        }

      })
    },
    initData() {
      getHealthAssessmen({
        elderlyId: this.row.id,
        nursinghomeId: this.row.nursinghomeId,
      }).then((res) => {
        if (JSON.stringify(res.data) != '{}'){
          // for(let i=0;i<this.propsList.length;i++){
            // this.form.tableData[i].score = res.data[this.propsList[i]]
            this.form.tableData = res.data
            // }
            this.totalScoreCalculate()
        }

      });
    },
    saveRecord() {
      this.$refs['formRef'].validate((valid) => {
          if (valid) {
            let obj ={}
            // for(let i=0;i<this.propsList.length;i++){
            //   obj[this.propsList[i]] = this.form.tableData[i].score
            // }
            obj.elderlyId = this.row.id
            obj.nursinghomeId = this.row.nursinghomeId
            obj.totalScore = this.totalScore
            obj.healthAssessment = this.form.tableData
            submitAssessment(obj).then((res) => {
              this.$message.success('提交成功');
              this.initData()
              this.$emit('success');
            });
          }
        });
    },
    cancleRecord() {
      this.$emit('cancle');
    },
  },
};
</script>
<style scoped>
.alarmClass {
  height: 100%;
  display: flex;
  justify-content: space-between;
  flex-direction: column;
}
::v-deep .el-col-8 {
  height: 54px;
}
</style>
